<template>
  <div >
    <!--Stats cards-->

     <div class="row text-center justify-content-center">
      <div
        class="col-md-6 col-xl-4 "
        v-for="pag in paginas"
        :key="pag.title"
      >
        <!-- <stats-card>
          <div
            class="icon-big text-center"
            :class="`icon-${pag.type}`"
            slot="header"
          >
            <i :class="pag.icon"></i>
          </div>
          <div class="numbers" slot="content">
            <p>{{ pag.title }}</p>
            {{ pag.value }}
          </div>
          <div class="stats bg-primary text-white py-2" slot="footer">
            <i :class="pag.footerIcon"></i> <a :href="pag.footerText" target="_blank" class="text-white"> <b> Ir a la pagina </b></a>
          </div>
        </stats-card> -->
      </div>
    </div>


      <!-- tabs -->

      <!-- <div>
        <b-tabs content-class="mt-3" align="center">
          <b-tab title="First" active><p>I'm the first tab</p></b-tab>
          <b-tab title="Second"><p>I'm the second tab</p></b-tab>
          <b-tab title="Second"><p>I'm the second tab</p></b-tab>
        </b-tabs>
      </div> -->

      
    


      <hr>

      <!-- <nav class="navbar bg-primary text-white justify-content-center" data-bs-theme="dark">
        <div class="container-fluid">
          <a class="navbar-brand" href="#"> <h4>SISTEMAS ADMINISTRATIVOS</h4> </a>
          <a class="navbar-brand" href="#"> <h4>SISTEMAS ACADEMICOS</h4> </a>
          <a class="navbar-brand" href="#"> <h4>OTROS SISTEMAS</h4> </a>
        </div>
        
      </nav> -->


     <div class="">
        <b-navbar toggleable="xl" type="dark" variant="primary">

          <b-navbar-toggle target="navbar-toggle-collapse">
            <template #default="{ expanded }">
              <b-icon v-if="expanded" icon="chevron-bar-up" class="text-white"></b-icon>
              <b-icon v-else icon="chevron-bar-down" class="text-white"></b-icon>
            </template>
          </b-navbar-toggle>

          <b-collapse  id="navbar-toggle-collapse" is-nav style="justify-content: space-around;"  >
            <b-navbar-nav >
              <b-nav-item @click="mostrarbloque('adm')" > <h3 class="my-0 py-0"> <b> SISTEMAS ADMINISTRATIVOS </b></h3></b-nav-item>
              <b-nav-item @click="mostrarbloque('aca')"><h3 class="my-0 py-0"> <b> SISTEMAS ACADEMICOS </b></h3></b-nav-item>
              <b-nav-item @click="mostrarbloque('otro')"><h3 class="my-0 py-0"><b>  OTROS SISTEMAS </b></h3></b-nav-item>
            </b-navbar-nav>

          </b-collapse>
        </b-navbar>
      </div>

     




 

    <div v-if="habilitaradm" class="row text-center justify-content-center align-items-center">

      <div class="col-12">
          <h2> <b class="text-white"> Sistemas Administrativos </b></h2>

      </div>
      
      <div
        class="col-md-6 col-xl-4"
        v-for="adm in administrativos"
        :key="adm.id"
      >
        <stats-card v-if="adm.sistema.TipoSistema == 2">
          <div class=" icon-big text-center" slot="header">
            <i class="ti-bar-chart"></i>
          </div>


          <div class="numbers" slot="content">
            <p>{{ adm.sistema.Nombre }}</p>
            {{ adm.sistema.Descripcion }}
            
<!--             <p >  <a :href="rutaApp +'storage/documents/' + adm.sistema.Manual" target="_blank" class="text-primary"> <i class="ti-eye"></i> <b> Ver manual</b></a></p>
 -->

          </div>

          
          <div class="stats  bg-warning text-white py-2" slot="footer">
              <i class="ti-eye"></i> <a :href="rutaApp +'storage/documents/' + adm.sistema.Manual" target="_blank" class="text-white"> <b> Ver manual </b></a>
          </div>
          <!-- <div class="stats col-6 bg-secondary text-white py-2" slot="footer">
            <i class="ti-eye"></i> <a :href="adm.sistema.URL" target="_blank" class="text-white"> <b> Ver manual</b></a>
          </div> -->
        </stats-card>
      </div>
    </div>

    <!-- <hr> -->


    <div v-if="habilitaraca" class="row text-center justify-content-center align-items-center">

      <div class="col-12">
          <h2> <b class="text-white"> Sistemas Académicos </b></h2>

      </div>
      
      <div
        class="col-md-6 col-xl-4"
        v-for="aca in academicos"
        :key="aca.id"
      >
        <stats-card v-if="aca.sistema.TipoSistema == 1">
         <div class=" icon-big text-center" slot="header">
            <i class="ti-book"></i>
          </div>

          <div class="numbers" slot="content">
            <p>{{ aca.sistema.Nombre }}</p>
            {{ aca.sistema.Descripcion }}
<!--             <p >  <a :href="rutaApp +'storage/documents/' + aca.sistema.Manual" target="_blank" class="text-primary"> <i class="ti-eye"></i> <b> Ver manual</b></a></p>
 -->

              
          </div>
          <div class="stats bg-info text-white py-2" slot="footer">
            <i class="ti-eye"></i> <a :href="rutaApp +'storage/documents/' + aca.sistema.Manual" target="_blank" class="text-white"> <b> Ver manual </b></a>
          </div>
        </stats-card>
      </div>
    </div>


     <!-- <hr> -->

    <div v-if="habilitarotros" class="row text-center justify-content-center align-items-center">

      <div class="col-12">
          <h2> <b class="text-white"> Otros Sistemas </b></h2>
  
      </div>
      <div
        class="col-md-6 col-xl-4"
        v-for="ot in otros"
        :key="ot.id"
      >
        <stats-card v-if="ot.sistema.TipoSistema != 1 && ot.sistema.TipoSistema != 2">
          <div class=" icon-big text-center" slot="header">
            <i class="ti-cloud"></i>
          </div>
          <div class="numbers" slot="content">
            <p>{{ ot.sistema.Nombre }}</p>
            {{ ot.sistema.Descripcion }}

<!--             <p >  <a :href="rutaApp +'storage/documents/' + ot.sistema.Manual" target="_blank" class="text-primary"> <i class="ti-eye"></i> <b> Ver manual</b></a></p>
 -->

          </div>
          <div class="stats bg-secondary text-white py-2" slot="footer">
            <i class="ti-eye"></i> <a :href="rutaApp +'storage/documents/' + ot.sistema.Manual" target="_blank" class="text-white"> <b> Ver manual </b></a>
          </div>
        </stats-card>
      </div>

      <!-- <div>
        <h3 v-if="ot.sistema.TipoSistema != 1 && ot.sistema.TipoSistema != 2"> No hay sistemas disponibles para usted</h3>
      </div> -->
    </div>
  
  </div>
</template>
<script>
import { StatsCard, ChartCard } from "@/components/index";
// import Chartist from "chartist";
import MainService from "@/services/MainService.js";

export default {

  metaInfo: {
    // Configura los encabezados de respuesta para evitar la caché
    httpEquiv: {
      'Cache-Control': 'no-store',
      Expires: 'Thu, 01 Jan 1970 00:00:00 GMT',
      Pragma: 'no-cache'
    }
  },
  
  components: {
    StatsCard,
    ChartCard,
  },
  /**
   * Chart data used to render stats, charts. Should be replaced with server data
   */
  data() {
    return {
      ss: new MainService(),

      // statsCards: [
      //   {
      //     type: "warning",
      //     icon: "ti-server",
      //     title: "Inscripciones PreUniversitario",
      //     value: "SIPRE",
      //     footerText: "http://admision.servicios.emi.edu.bo/",
      //     footerIcon: "ti-arrow-right",
      //   },
      //   {
      //     type: "success",
      //     icon: "ti-wallet",
      //     title: "Inscripciones Regulares",
      //     value: "REGULARES",
      //     footerText: "Last day",
      //     footerIcon: "ti-arrow-right",
      //   },
      //   {
      //     type: "danger",
      //     icon: "ti-pulse",
      //     title: "Inscripciones Posgrado",
      //     value: "SINPO",
      //     footerText: "In the last hour",
      //     footerIcon: "ti-arrow-right",
      //   },
      //   {
      //     type: "info",
      //     icon: "ti-twitter-alt",
      //     title: "Kardex Estudiantes Grado",
      //     value: "SKEG",
      //     footerText: "https://kardex.servicios.emi.edu.bo/",
      //     footerIcon: "ti-arrow-right",
      //   },
       

      //    {
      //     type: "info",
      //     icon: "ti-twitter-alt",
      //     title: "Repositorio Grado",
      //     value: "REGRA",
      //     footerText: "https://repositoriogrado.servicios.emi.edu.bo/",
      //     footerIcon: "ti-arrow-right",
      //   },


      //    {
      //     type: "info",
      //     icon: "ti-twitter-alt",
      //     title: "Repositorio Posgrado",
      //     value: "REPOS",
      //     footerText: "http://repositorioposgrado.servicios.emi.edu.bo/",
      //     footerIcon: "ti-arrow-right",
      //   },



      //    {
      //     type: "info",
      //     icon: "ti-twitter-alt",
      //     title: "Biblioteca",
      //     value: "SISBLI",
      //     footerText: "https://biblioteca.servicios.emi.edu.bo/",
      //     footerIcon: "ti-arrow-right",
      //   },
      //   {
      //     type: "info",
      //     icon: "ti-twitter-alt",
      //     title: "Emision de certificados",
      //     value: "SISCER",
      //     footerText: "https://cursos.servicios.emi.edu.bo/",
      //     footerIcon: "ti-arrow-right",
      //   }
      // ],

      paginas: [
        {
          type: "primary",
          icon: "ti-world",
          title: "PAGINA WEB ",
          value: "EMI",
          footerText: "http://emi.edu.bo/",
          footerIcon: "ti-arrow-right",
        },
      
      ],

      sistemasper:[],
      rutaApp:process.env.VUE_APP_RRHH_SERVICE,

      
      academicos:[], //1
      administrativos:[], //2
      otros:[], //otro

      habilitaradm:true,
      habilitaraca:false,
      habilitarotros:false,
     
    };
  },

   methods: {
  

    mostrarbloque(tipo)
    {
      // console.log("sistemas",tipo);

      if(tipo == 'adm'){
        this.habilitaradm=true;
        this.habilitaraca=false;
        this.habilitarotros=false;
      }
      if(tipo == 'aca'){
        this.habilitaradm=false;
        this.habilitaraca=true;
        this.habilitarotros=false;
      }
      if(tipo == 'otro'){
        this.habilitaradm=false;
        this.habilitaraca=false;
        this.habilitarotros=true;
      }

      

    },

    showPersona() {
      console.log("show");
            
            this.ss.showPersona(this.auth.id).then(
                (result) => {
                    let response = result.data;
                    this.persona = response.data;
                    console.log(this.persona);

                    // this.$refs['view-usuario'].show();
                    // this.isLoading=false;
                }
            ).catch(error => {
                console.log(error);
                this.isLoading=false;
            });
    },

    getSistemasPersona() {
      // console.log("list SIS");

      this.academicos=[];
      this.administrativos=[];
      this.otros=[];
            
        this.ss.listSistemasPersona(this.auth.id).then(
            (result) => {
                let response = result.data;
                this.sistemasper = response.data;

                for(let i = 0 ;i < this.sistemasper.length; i++){
                    // console.log("sistema ...",this.sistemasper[i])
                    if(this.sistemasper[i].sistema.TipoSistema == 1){
                      // academicos
                      // console.log("sistema academico",this.sistemasper[i])
                      this.academicos.push(this.sistemasper[i]);

                    }

                    if(this.sistemasper[i].sistema.TipoSistema == 2){
                      // academicos
                      // console.log("sistema academico",this.sistemasper[i])
                      this.administrativos.push(this.sistemasper[i]);

                    }

                    if(this.sistemasper[i].sistema.TipoSistema == 3){
                      // academicos
                      // console.log("sistema academico",this.sistemasper[i])
                      this.otros.push(this.sistemasper[i]);

                    }
                }

                // console.log("sistemas",this.academicos);
                // console.log("sistemas",this.administrativos);
                // console.log("sistemas",this.otros);

                


                

                
            }
        ).catch(error => {
            console.log(error);
            this.isLoading=false;
        });
    },


    print(){
      console.log("hola");
    }
  },

   mounted() {
        this.auth = JSON.parse(localStorage.getItem('usuario'));
        //console.log(this.auth);
        if (!this.auth) {
            this.$router.push('/Login');
        } else {
            
            // this.showPersona();
            // this.print();
            this.getSistemasPersona();
            
        }
    }
};
</script>
<style></style>
